export const statusPayment = status => {
    switch ( String(status) ) {
        case 'CREDIT_SHIPPOP':
            return { title: `วางบิลโดยระบบ Business` , color: `text-success`}
        case 'PREPAID':
            return { title: `ชำระเงินทันที` , color: `text-success` } 
        case 'MONTHLY':
            return { title: `รายเดือน` , color: `text-success` } 
        case 'DAILY':
            return { title: `รายวัน` , color: `text-success` } 
        case 'WEEKLY':
            return { title: `รายสัปดาห์` , color: `text-success` } 
        default:
            return { title: `-` }
    }
};